import { colors } from 'styles/theme/colors';

// Checked box: a rounded square filled with `currentColor` and a white check drawn on top.
//
// The check is stroked rather than knocked out of the fill. A knockout shows whatever sits
// behind the icon, which reads as white only because most rows happen to be white -- on a
// tinted surface it picked up that surface's colour.
//
// The rect spans the full 24x24 viewBox with rx 3.5, matching the OUTER corner of
// CheckboxOffIcon's stroked rect, so checking a box changes its fill and nothing about its
// silhouette.
export default function CheckboxOnIcon({ width = 24, height = 24, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 24 24' version='1.1' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect x='0' y='0' width='24' height='24' rx='3.5' fill='currentColor' />
      <path
        d='M5.4,12.3 L9.9,16.8 L18.6,7.2'
        fill='none'
        stroke={colors.white}
        strokeWidth='2.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
